import React from 'react';

import Box from '../Box';

import { FlexCommonProps } from './Flex.common';

export type Props = React.ComponentProps<typeof Box> & FlexCommonProps;

function Flex({ htmlRef, ...props }: Props): JSX.Element {
  return <Box ref={htmlRef} display="flex" {...props} />;
}

/**
 * Flex is a layout component that applies flexbox display.
 * It's a specialized Box with display="flex" and gap support.
 *
 * READ THE DOCS: https://roverdotcom.atlassian.net/wiki/spaces/TECH/pages/5210898784/Kibble+Core+Flex
 */
export default Flex;
